import { PropTypes } from 'prop-types';
import {
  Table,
  TableHead,
  TableContainer,
  TableRow,
  TableCell,
  Box,
  Typography
} from "@mui/material";
import { useMemo } from 'react';
import { Duration } from 'luxon';

function SmartPTTable({ label, customersInQueue, amountOfServices, initialSuggestedTime }) {

  const suggestedTime = useMemo(() => {

    const waitingTime = initialSuggestedTime?.map((time) => {
      const [hours, minutes] = time.split(':').map(Number);
      const duration = Duration.fromObject({ hours, minutes });
      const minutesToAdd = customersInQueue * 10;
      const newDuration = duration.plus({ minutes: minutesToAdd }).normalize();;
      return `${newDuration.hours}:${newDuration.minutes.toString().padStart(2, '0')}`;
    });

    return waitingTime;

  }, [customersInQueue, initialSuggestedTime]);

  return (
    <Box>
      <Typography className='bg-yellow font-bold pl-1 text-sm'>
        {label}
      </Typography>
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                className='p-1 border border-solid border-gray-300 text-xs'
              >
                Services Requested
              </TableCell>
              {
                [...Array(amountOfServices)].map((service, index) => (
                  <TableCell
                    key={index}
                    component="th"
                    scope="row"
                    align="center"
                    className='p-1 border border-solid border-gray-300 text-xs'
                  >
                    {index + 1}
                  </TableCell>
                ))
              }
            </TableRow>
            <TableRow>
              <TableCell
                align="left"
                className='p-1 border border-solid border-gray-300 text-xs'
              >
                Suggested Time 
                <span className='text-neutral-500 ml-1 my-0'>(HH:MM)</span>
              </TableCell>
              {
                suggestedTime?.map((time, index) => (
                  <TableCell
                    key={index}
                    align="center"
                    className='p-1 border border-solid border-gray-300 text-xs'
                  >
                    {time}
                  </TableCell>
                ))
              }
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
    </Box>
  )
}

SmartPTTable.propTypes = {
  label: PropTypes.string.isRequired,
  customersInQueue: PropTypes.number.isRequired,
  amountOfServices: PropTypes.number.isRequired,
  initialSuggestedTime: PropTypes.array.isRequired
};

export default SmartPTTable;